export const FIELDS_TO_UPDATE = {
  DETAILS: 'judgementAdd',
  CIVIL_DOCUMENTS: 'civilDocuments',
  JUDGEMENT_PRONOUNCING: 'judgementAddDocuments',
};
export const CIVIL_DOC_ID = 'CIVIL_1';
